import request from '@/utils/request'
const rsa = require('../utils/rsa');

// 登录接口
export function login(data) {
    if (data.password) {
        data.password = rsa.default.rasEncry(data.password);
    }
    return request({
        url: '/login/?_allow_anonymous=true',
        method: 'post',
        data
    })
}

// 注册接口
export function register(data) {
    return request({
        url: '/person/register?_allow_anonymous=true',
        method: 'post',
        data
    })
}

// 获取验证码
export function getVerifyCode(email) {
    return request({
        url: '/send-register-verification-code?_allow_anonymous=true',
        method: 'post',
        data: {
            iden: email,
            typeEk: 'EMAIL'
        }
    })
}
// 重置密码验证码
export function getPasswordVerifyCode(email) {
    return request({
        url: '/send-reset-password-verification-code?_allow_anonymous=true',
        method: 'post',
        data: {
            iden: email,
            typeEk: 'EMAIL'
        }
    })
}
// 验证验证码是否正确
export function validVerCode(param) {
    return request({
        url: '/precede-login/get-pwd-code-by-vercode?_allow_anonymous=true',
        method: 'post',
        data: param
    })
}
// 确认重置密码
export function sureResetPassword(param) {
    if (param.password) {
        param.password = rsa.default.rasEncry(param.password);
    }
    return request({
        url: '/precede-login/reset-password?_allow_anonymous=true',
        method: 'post',
        data: param
    })
}
// 获取当前人员信息
export function getCurrentPerson() {
    return request({
        url: '/person/current',
        method: 'get'
    })
}

// 获取当前用户信息
export function getCurrentUser() {
    return request({
        url: '/user/current',
        method: 'get'
    })
}

// 获取当前用户信息
export function getCurrentPersonLoginInfo() {
    return request({
        url: '/module-data/jy_person/jy_person/diy/get-login-info',
        method: 'get'
    })
}

// 获取当前用户的TG账号名
export function getCurrentUserTgName() {
    return request({
        url: '/module-data/ts_send_strategy/ts_send_strategy/diy/get_tg_account',
        method: 'get'
    })
}

// 生成当前人员的邀请码
export function generateInvitationCode() {
    return request({
        url: '/person/generate-invit-code',
        method: 'get'
    })
}

// 保存个人资料
export function savePersonalData(data) {
    return request({
        url: '/person/updateCurrent',
        method: 'put',
        data
    })
}

// 上传个人头像
export function uploadPersonalHead(file) {
    console.log(file);
    return request({
        url: '/file/upload',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: {
            file: file,
            uploadType: 'LOCAL',
            permanentUrlFlag: true
        }
    })
}

// 开通会员付款
export function requestPay(data) {
    return request({
        url: '/module-data/jy_unique_amount/jy_unique_amount/diy/request_pay',
        method: 'post',
        data
    })
}